import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import jqueryReadmore from 'jquery-readmore';
import jqueryTinysort from 'jquery-tinysort';
import textAnswersTemplate from 'hbars!templates/textAnswers';

var QuestionResultsView = Backbone.View.extend({

    choicesColors: ['#d65d80', '#cf5e58', '#4c9ecd', '#7bac41', '#a864a8', '#f68e56', '#ada300', '#46a9a2', '#4978a6', '#f06eaa'],

    events: {
        'change select': 'renderOrder'
    },

    initialize: function(options) {
        this.render();

        this.listenTo(this.model, 'change', this.render);
        this.listenTo(this.model, 'reRenderResults', this.reRender);
        this.listenTo(this.model, 'emptyResults', this.emptyResults);

        this.readMore = options.readMore;
    },

    render: function() {
        var type = this.model.get('entryType');
        if ((type === 'CHOICES') || (type === 'SCALE')) {
            this.renderMultiChoiceAnswer();
        } else if (type === 'TEXT') {
            this.renderTextAnswers();
        }
    },

    renderTextAnswers: function(){
        var thisView = this;

        var textAnswersWrapperElement = this.$('.poll-question-text-answers');
        textAnswersWrapperElement.readmore('destroy');
        textAnswersWrapperElement.fadeOut(500, function() {
            textAnswersWrapperElement.html(textAnswersTemplate({
                results: thisView.model.toJSON()
            }));

            if (thisView.readMore) {
                textAnswersWrapperElement.readmore({
                    startOpen: thisView.readMoreOpen,
                    afterToggle: function(trigger, element, expanded) {
                        thisView.readMoreOpen = expanded;
                    }
                });
            }
        });
        textAnswersWrapperElement.fadeIn(500);
    },

    renderMultiChoiceAnswer: function() {
        var highestPercentage = this.model.getHighestPercentage() || 1;
        for (var choiceId in this.model.get('resultsPercentage')) {
            var color = this.choicesColors[choiceId % this.choicesColors.length];
            var styles = {
                'background-color': color,
                'width': (this.model.get('resultsPercentage')[choiceId]/highestPercentage) * 100 + '%'
            };
            if (this.model.get('resultsPercentage')[choiceId]===highestPercentage){
                this.$('.poll-question-choice[data-choice-id="'+choiceId+'"]').addClass('highest');
                this.$('.poll-question-choice[data-choice-id="'+choiceId+'"] .poll-choice-container-fill').addClass('poll-mobile-gradient-fill');
            }
            this.$('.poll-question-choice[data-choice-id="'+choiceId+'"] .poll-choice-container-fill').css(styles);

            var numberText = 0;
            switch (this.model.get('resultType')){
            case 'PERCENT':
                numberText = this.model.get('resultsPercentage')[choiceId] + '%';
                break;
            case 'COUNT':
                numberText = this.model.get('results')[choiceId];
                break;
            }

            this.$('.poll-question-choice[data-choice-id="'+choiceId+'"] .poll-choice-number-container').text(numberText);
        }

        _.delay(this.renderOrder, 1000);
    },

    reRender: function() {
        this.emptyResults();

        this.$('.poll-question-choice .poll-choice-container-fill').removeClass('notransition');

        var thisView = this;
        setTimeout(function(){
            thisView.render();
        }, 0);
    },

    emptyResults: function() {
        this.$('.poll-question-choice .poll-choice-container-fill').addClass('notransition');

        if (!_.isEmpty(this.model.get('resultsPercentage'))){
            this.$('.poll-question-choice .poll-choice-container-fill').css('width', 0);
            this.$('.poll-question-choice .poll-choice-number-container').text('');
        } else if (!_.isEmpty(this.model.get('textResults'))){
            this.$('.poll-question-text-answers').empty();
        }
    },

    renderOrder: function() {
        var val = this.$('select').val();
        switch (val){
        case 'default':
            this.$('.poll-question-choice').tsort({
                attr: 'data-position'
            });
            break;
        case 'voted-desc':
            this.$('.poll-question-choice').tsort('.poll-choice-number-container', {
                sortFunction: function(a, b) {
                    return (parseInt(a.s[0], 10) < parseInt(b.s[0], 10)) ? 1 : -1; // removes the '%' if exists
                }
            });
            break;
        }
    }

});

export default QuestionResultsView;


